export default __webpack_public_path__ + "02a95cc15a06c70d328dcc47a38837bc.svg";